/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRampLeft3 = createReactComponent("arrow-ramp-left-3", "IconArrowRampLeft3", [
  ["path", { d: "M18 3v6", key: "svg-0" }],
  ["path", { d: "M8 16l-4 -4l4 -4", key: "svg-1" }],
  ["path", { d: "M18 21v-6a3 3 0 0 0 -3 -3h-11", key: "svg-2" }]
]);

export { IconArrowRampLeft3 as default };
//# sourceMappingURL=IconArrowRampLeft3.js.map
